import { useFlags as useFlagsLD } from 'launchdarkly-react-client-sdk';
import { Flags } from './flagType';

export function useFlags() {
  const flags = useFlagsLD();

  return flags as Flags;
}
